import React from 'react';
import './style.scss';
import { resolveLocalizedText } from '../../../../utils';

export interface CustomerProfileErrorProps {
  label: any;
  tryAgainCallback: () => void;
  callCsCallback: () => void;
}

export const CustomerProfileError = ({
  label,
  tryAgainCallback,
  callCsCallback,
}: CustomerProfileErrorProps) => {
  const { errorPageTitle, errorPageMessage, tryAgainBtn, callCSBtn } = label;

  return (
    <div className="customer-profile-error-container">
      <div className="heading">
        {errorPageTitle ? resolveLocalizedText(errorPageTitle) : ''}
      </div>
      <div className="error-message">
        {errorPageMessage ? resolveLocalizedText(errorPageMessage) : ''}
      </div>
      <div className="btn-wrapper">
        <button
          data-enable-ga
          data-ga-type="button"
          className="emma-stylesheet-primary-default-button"
          onClick={tryAgainCallback}
        >
          {tryAgainBtn ? resolveLocalizedText(tryAgainBtn) : ''}
        </button>
        <button
          data-enable-ga
          data-ga-type="button"
          className="emma-stylesheet-primary-ghost-button"
          onClick={callCsCallback}
        >
          {callCSBtn ? resolveLocalizedText(callCSBtn) : ''}
        </button>
      </div>
    </div>
  );
};
